export default "__VITE_ASSET__f2e37596__"